import { Protocol } from '../Protocol';

export class KeyManagementProtocol {
  public static readonly POST_APPLY_SEND: string = `${Protocol.YATUNG_API_ROOT}/apply/V2/send`;
  public static readonly GET_APPLY_SEARCH: string = `${Protocol.YATUNG_API_ROOT}/apply/V2/search`;
  public static readonly GET_APPLY_CANCEL: string = `${Protocol.YATUNG_API_ROOT}/apply/V2/cancel`;
  public static readonly PUT_APPLY_DESCRIPTION: string = `${Protocol.YATUNG_API_ROOT}/apply/V2/description`;
}
